// routes placeholder

export const adminRoutes = [
  // { path: '/admin/dashboard', label: 'Dashboard', icon: '📊' },
  { path: '/admin/users', label: 'Users', icon: '👥' },
  // { path: '/admin/coupons', label: 'Coupons', icon: '🎫' },
  { path: '/admin/transactions', label: 'Sales', icon: '💰' },
  { path: '/admin/games', label: 'Games', icon: '🎮' },
  // { path: '/admin/settings', label: 'Settings', icon: '⚙️' }
];
